// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4521) return "static/chunks/4521-ffea1cbc224ca843.js";
	if (chunkId === 1166) return "static/chunks/1166-d1e38d6479478f20.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3442":"c3323b9abd42192b","7879":"d6bd66d2deb102b0","8250":"9c8d0c55c2f37131","8536":"9751d560f4b9afca","9814":"bdb86d2ebbde293e"}[chunkId] + ".js";
};